import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import { StaticImage } from "gatsby-plugin-image";
import BgImg from "../../../images/case-studies/serve-easy/banner.webp";
import {
  CaseStudyServeEasy,
} from "../../../../app-constants-updated";
// import styles from '../../style/case-studies/serve-easy/_banner.scss';


function Banner() {
  return (
    <section className="banner-serve-easy text_white" style={{ backgroundImage: `url(${BgImg})` }}>
      <Container className="h-100">
        <Row className="h-100 ">
          <Col xs={12} md={6} lg={6} xl={6} xxl={6} className="my-auto">
            <div className="content">
              <span className="icon">{CaseStudyServeEasy}</span>
              <h1>ServeEasy App Built from <br/>Ground Up for <strong>Superior CX</strong></h1>
            <p>A cloud-powered POS for cafés & hotels.</p>
            </div>
          </Col>
          <Col
            xs={12}
            md={6}
            lg={6}
            xl={6}
            xxl={6}
            className="mt-auto text-center position-relative px-lg-0"
          >
            <div className="banner_img">
              <StaticImage
                src="../../../images/case-studies/serve-easy/banner-screen-v2.webp"
                alt="TekRevol"
                className=""
                layout="constrained"
                placeholder="blurred"
                formats={["webp"]}
                width={810}
                height={621}
              />
            </div>
          </Col>
        </Row>
      </Container>
    </section>
  );
}

export default Banner;
